

import React, { useEffect, useState } from "react";
import { Table, Card, CardHeader, CardBody, Input, Row, Col, CardTitle } from "reactstrap";
import useToken from "../../helpers/useToken"
import useTimeZone from "../../helpers/useTimeZone"
import TMHLoader from "../TMHLoader/TMHLoader";
import { Link } from "react-router-dom";
import PaginationCustom from "../PaginationCustom/PaginationCustom"
import { parseCustomTime } from "../../helpers/utils";

export default function IPTable() {
    const { token } = useToken()
    const { timeZone } = useTimeZone()
    const [IPs, setIPs] = useState()
    const [pager, setPager] = useState({
        size: 10,
        offset: 0,
        text: '',
        user_agent: 'ALL'
    });
    const [totalIP, setTotalIP] = React.useState(0);
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const initData = () => {
            setIsLoading(true)
            console.log('IPTable: get data')
            const myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            const requestOptions = {
                method: 'GET',
                headers: myHeaders
            };

            var params = new URLSearchParams({
                'page_size': pager.size,
                'offset': pager.offset,
                'search_text': pager.text,
                'user_agent': pager.user_agent
            })

            fetch(process.env.REACT_APP_BASE_URL + "IPs?" + params, requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        var json = result.json
                        // console.log(json)
                        if (result.ok) {
                            setIPs(json.data)
                            setTotalIP(json.page_dto.total)
                        }
                        else {
                            // console.log(result.json.message)

                        }
                        setIsLoading(false)
                    }
                )
        }

        initData()
    }, [pager, token])


    return (

        <TMHLoader active={isLoading}>
            <Card>
                <CardHeader>
                    <CardTitle className="text-center" tag="h2">
                        IP List ({totalIP})
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <Row className="mb-2">
                        <Col md="4" className="pt-1">
                            Shows {" "}
                            <select value={pager?.size} onChange={(e) => setPager({ ...pager, size: e.target.value, offset: 0 })}>
                                <option>10</option>
                                <option>25</option>
                                <option>50</option>
                                <option>100</option>
                            </select> entries
                        </Col>
                        <Col md="4">
                            <Input
                                placeholder="Search IP, UserID, Country Code,..."
                                type="text"
                                onChange={(e) => {
                                    let text = e.target.value.replace(/\s/g, '')
                                    setPager({ ...pager, offset: 0, text: text })
                                }}
                            />
                        </Col>
                        <Col md="4" className="pt-1">
                            Platform: {" "}
                            <select value={pager?.user_agent} onChange={(e) => setPager({ ...pager, user_agent: e.target.value, offset: 0 })}>
                                <option>ALL</option>
                                <option>Roku</option>
                                <option>Web & Other</option>
                            </select>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Table striped className="tablesorter">
                                <thead className="text-primary">
                                    <tr>
                                        <th>IP Address</th>
                                        <th>User ID</th>
                                        <th>User Agent</th>
                                        <th>Country Code</th>
                                        <th>City</th>
                                        <th>Region</th>
                                        <th>Last Active</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        IPs?.map((userIP) => {
                                            return (<tr key={userIP.id}>
                                                <td>{userIP.ip_address}</td>
                                                <td>
                                                    {
                                                        (userIP.user_id !== -1)  &&
                                                        <Link to={"/edit-user/" + userIP.user_id} target="_blank" >
                                                            {userIP.user_id}
                                                        </Link>
                                                    }
                                                </td>

                                                <td>{userIP.user_agent}</td>
                                                <td>{userIP.country_code}</td>
                                                <td>{userIP.city}</td>
                                                <td>{userIP.region}</td>
                                                <td>{parseCustomTime(userIP.updated_at, timeZone)}</td>
                                            </tr>)
                                        })
                                    }
                                </tbody>
                            </Table>

                            <PaginationCustom pager={pager} total={totalIP} setPager={setPager} />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </TMHLoader>
    );
}